<template>
  <div>
    <el-card class="box-card">
      <div slot="header">
        <!-- 标题 -->
        <span class="font-sz24">实景标签配置</span>
        <div class="head-text">
          <el-button
            type="primary"
            @click="
              dialogVisible = true;
              isAdd = true;
            "
            >新建</el-button
          >
        </div>
      </div>
      <div class="rygl-table">
        <el-table
          :data="tableData"
          height="72vh"
          class="width100"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            align="center"
            width="55"
          ></el-table-column>
          <el-table-column
            prop="Name"
            align="center"
            label="类型"
          ></el-table-column>
          <el-table-column prop="lbst04" align="center" label="图片">
            <template slot-scope="scope">
              <img
                :src="$store.state.baseUrl + scope.row.lbst04"
                width="30px"
                alt
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                plain
                @click="upadataLive(scope.row)"
                >修改</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      title="新建"
      :visible.sync="dialogVisible"
      width="40%"
      height="30%"
    >
      <el-row class="height100p">
        <el-col :span="6">
          <el-select filterable v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6" :offset="3">
          <el-upload
            class="upload-demo"
            ref="upload"
            :action="actionUrl"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-upload="handleBefore"
            :file-list="fileList"
            :data="aaa"
            :headers="importHeaders"
            :on-success="handleSuccess"
            list-type="picture"
          >
            <el-button slot="trigger" size="small" type="primary"
              >选取文件</el-button
            >
          </el-upload>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="修改"
      :visible.sync="dialogVisible2"
      width="40%"
    >
      <el-row class="height100p">
        <el-col :span="6">
          <el-select filterable v-model="value" placeholder="请选择" disabled>
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6" :offset="3">
          <el-upload
            class="upload-demo"
            ref="upload"
            :action="actionUrl"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-upload="handleBefore"
            :file-list="fileList"
            :data="aaa"
            :headers="importHeaders"
            :on-success="handleSuccess"
            list-type="picture"
          >
            <el-button slot="trigger" size="small" type="primary"
              >选取文件</el-button
            >
          </el-upload>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { GetModelLableSets } from "@/setAxios";
export default {
  data() {
    return {
      isAdd: false,
      multipleSelection: [],
      actionUrl: this.$store.state.baseUrl + "/api/UpdalodModelLableSet",
      dialogVisible: false,
      dialogVisible2: false,
      options: [
        {
          value: 1,
          label: "图片",
        },
        {
          value: 2,
          label: "全景",
        },
        {
          value: 3,
          label: "视频",
        },
      ],
      value: 1,
      imgUrl: "",
      fileList: [],
      aaa: {},
      importHeaders: { token: localStorage.getItem("token") },
      tableData: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.GetModelLableSets2();
    },
    upadataLive(row) {
      this.isAdd = false;
      this.dialogVisible2 = true;
      this.value = row.lbst03;
    },
    GetModelLableSets2() {
      let params = {
        xid: localStorage.getItem("xid"),
      };
      GetModelLableSets({ params }).then((res) => {
        //(res);
        this.tableData = res.Data;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handlePreview(file) {
      //(file);
    },
    handleRemove(file, fileList) {
      //(file, fileList);
    },
    handlePreview(file) {
      //(file);
    },
    handleBefore(file) {
      // debugger;
      var testmsg = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase();
      //(file);
      const extension = testmsg == "jpg";
      const extension2 = testmsg == "png";
      const isLt2M = file.size / 1024 / 1024 <= 2;
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是 jpg,png格式!",
          type: "warning",
        });
        return false;
      }
      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 2MB!",
          type: "warning",
        });
        return false;
      }
      let fd = new FormData();
      this.aaa.xid = localStorage.getItem("xid");
      this.aaa.qid = localStorage.getItem("pid");
      this.aaa.type = this.value;
      fd.append("file", file);
      fd.append("model", this.aaa);
    },
    handleSuccess(response, file, fileList) {
      if (response.Code > 0) {
        // this.imgUrl = this.$store.state.baseUrl + res.Data;
        this.$message({
          type: "success",
          message: "上传成功",
        });
        if (this.isAdd) {
          this.dialogVisible = false;
        } else {
          this.dialogVisible2 = false;
        }
        this.GetModelLableSets2();
      }
    },
  },
};
</script>
<style scoped>
/* 新增 */
.font-sz24 {
  font-size: 24px;
}
.head-text {
  float: right;
  margin-top: -4px;
}
.width100 {
  width: 100%;
}
.height100p {
  height: 100px;
}
</style>
